import e from "react";
import { Stack as n, Box as c, Typography as d } from "@mui/material";
import { B as r } from "./chunk.hFvqNSIf.js";
import { D as s } from "./chunk.C-7NlM7C.js";
import { D as C } from "./chunk.BNOxK3q-.js";
const g = (i) => /* @__PURE__ */ e.createElement(n, { direction: "row", spacing: 1, justifyContent: "left" }, i.onCancelClick && /* @__PURE__ */ e.createElement(
  c,
  {
    sx: {
      minWidth: 200
    }
  },
  /* @__PURE__ */ e.createElement(
    r,
    {
      buttonText: "Cancel",
      variant: "outlined",
      fullWidth: !0,
      onClick: i.onCancelClick
    }
  )
), /* @__PURE__ */ e.createElement(
  c,
  {
    sx: {
      minWidth: 200
    }
  },
  i.onUploadClick && /* @__PURE__ */ e.createElement(
    r,
    {
      buttonText: "Upload",
      variant: "contained",
      fullWidth: !0,
      loading: i.loading,
      onClick: i.onUploadClick
    }
  )
)), k = (i) => /* @__PURE__ */ e.createElement(n, { spacing: 1, sx: { marginTop: "20px" } }, /* @__PURE__ */ e.createElement(d, { variant: "h3" }, "Documents"), i.documents.map((a) => /* @__PURE__ */ e.createElement(
  s,
  {
    key: a.file.name,
    labelText: a.file.name,
    descriptionText: a.status === "loading" ? "Uploading..." : a.errorMessage,
    status: a.status === "new" ? void 0 : a.status,
    primaryAction: a.primaryAction ? {
      ariaLabel: a.primaryAction.ariaLabel || a.primaryAction.label,
      icon: a.primaryAction.icon,
      onClick: () => {
        var t;
        return (t = a.primaryAction) == null ? void 0 : t.onClick(a);
      }
    } : void 0,
    additionalActions: a.additionalActions ? a.additionalActions.length > 1 ? a.additionalActions.map((t) => ({
      icon: t.icon,
      label: t.label,
      onClick: () => t.onClick(a)
    })) : {
      ariaLabel: a.additionalActions[0].ariaLabel,
      icon: a.additionalActions[0].icon,
      onClick: () => a.additionalActions[0].onClick(a)
    } : void 0
  }
))), y = (i) => {
  const a = async (t, l) => {
    const o = t.map((m) => ({
      file: m,
      status: i.immediate ? "loading" : "new"
    }));
    i.onDocumentAdded && i.onDocumentAdded(o, l), i.immediate && i.onUpload(o, l);
  };
  return /* @__PURE__ */ e.createElement(n, { spacing: 2 }, /* @__PURE__ */ e.createElement(
    C,
    {
      extensions: i.extensions,
      onDropFiles: a,
      maxSize: i.maxSize,
      multiple: i.multiple,
      showEmptyState: i.documents.length === 0
    },
    i.documents.length > 0 && /* @__PURE__ */ e.createElement(k, { documents: i.documents })
  ), /* @__PURE__ */ e.createElement(
    g,
    {
      loading: i.documents.some((t) => t.status === "loading"),
      onUploadClick: i.immediate ? void 0 : i.onUpload,
      onCancelClick: i.onCancel
    }
  ));
};
export {
  y as F
};
